export default {
  getPlayBookModule: state => state.playBookModule,
};
